import React, { useEffect, useState } from "react";
import "../Header.css";
import logo from "../../assets/logo-4.png";

import { NavLink } from "react-router-dom";
import {
  FiChevronDown,
  FiMenu,
  FiX
} from "react-icons/fi";

const Header = () => {
  const [mobileMenu, setMobileMenu] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  const [openDropdown, setOpenDropdown] = useState("");

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 40);
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const toggleDropdown = (menu) => {
    setOpenDropdown(openDropdown === menu ? "" : menu);
  };

  const closeMenu = () => {
    setMobileMenu(false);
    setOpenDropdown("");
  };

  return (
    <header className={`header ${scrolled ? "scrolled" : ""}`}>
      <div className="container header-container">

        {/* Logo */}

        <NavLink
          to="/"
          className="logo"
          onClick={closeMenu}
        >
          <img src={logo} alt="Kishancart Digital" />
        </NavLink>

        {/* Desktop Navigation */}

        <nav className="desktop-nav">

          <NavLink to="/" end className="nav-link"
            onClick={(e) => {
              e.preventDefault();
              window.location.href = "/";
            }}
          >
            Home
          </NavLink>

          {/* Company */}

          <div className="dropdown">

            <button className="dropdown-btn">
              Company
              <FiChevronDown />
            </button>

            <div className="dropdown-menu">

              <NavLink to="/about" 
               onClick={(e) => {
                e.preventDefault();
                window.location.href = "/about";
              }}
              >
                About Us
              </NavLink>

              <NavLink to="/our-story"
               onClick={(e) => {
                e.preventDefault();
                window.location.href = "/our-story";
              }}
              >
                Our Story
              </NavLink>

              <NavLink to="/mission-vision"
               onClick={(e) => {
                e.preventDefault();
                window.location.href = "/mission-vision";
              }}
              >
                Mission & Vision
              </NavLink>



            </div>

          </div>



          {/* Solutions */}

          <div className="dropdown">

            <button className="dropdown-btn">
              Solutions
              <FiChevronDown />
            </button>

            <div className="dropdown-menu">

              <NavLink to="/retail"
               onClick={(e) => {
                e.preventDefault();
                window.location.href = "/retail";
              }}
              >
                Retail
              </NavLink>

              <NavLink to="/healthcare"
               onClick={(e) => {
                e.preventDefault();
                window.location.href = "/healthcare";
              }}
              >
                Healthcare
              </NavLink>

              <NavLink to="/agriculture"
               onClick={(e) => {
                e.preventDefault();
                window.location.href = "/agriculture";
              }}
              >
                Agriculture
              </NavLink>


              <NavLink to="/education"
               onClick={(e) => {
                e.preventDefault();
                window.location.href = "/education";
              }}
              >
                Education
              </NavLink>

              <NavLink to="/manufecturing"
               onClick={(e) => {
                e.preventDefault();
                window.location.href = "/manufecturing";
              }}
              >
                Manufacturing
              </NavLink>

              <NavLink to="/logistics"
               onClick={(e) => {
                e.preventDefault();
                window.location.href = "/logistics";
              }}
              >
                Logistics
              </NavLink>

              <NavLink to="/grocery"
               onClick={(e) => {
                e.preventDefault();
                window.location.href = "/grocery";
              }}
              >
                Grocery
              </NavLink>

              <NavLink to="/fashion"
               onClick={(e) => {
                e.preventDefault();
                window.location.href = "/fashion";
              }}
              >
                Fashion
              </NavLink>



            </div>

          </div>

          {/* Industries */}

          {/* <div className="dropdown">

            <button className="dropdown-btn">
              Industries
              <FiChevronDown />
            </button>

            <div className="dropdown-menu">

              <NavLink to="/retail-industry">
                Retail
              </NavLink>

              <NavLink to="/healthcare">
                Healthcare
              </NavLink>

              <NavLink to="/manufacturing">
                Manufacturing
              </NavLink>

              <NavLink to="/education">
                Education
              </NavLink>

              <NavLink to="/agriculture">
                Agriculture
              </NavLink>

            </div>

          </div> */}

          <NavLink to="/contact" className="nav-link"
          
           onClick={(e) => {
                e.preventDefault();
                window.location.href = "/contact";
              }}
          >
            Contact
          </NavLink>

        </nav>

        {/* CTA */}

        <div className="header-right">

          <NavLink
            to="/get-quote"
            className="quote-btn"

             onClick={(e) => {
                e.preventDefault();
                window.location.href = "/get-quote";
              }}
          >
            Get Quote
          </NavLink>

          <button
            className="menu-btn"
            onClick={() => setMobileMenu(!mobileMenu)}
          >
            {mobileMenu ? <FiX /> : <FiMenu />}
          </button>

        </div>

      </div>

      {/* Mobile Navigation */}

      <div className={`mobile-nav ${mobileMenu ? "show" : ""}`}>

        <NavLink to="/" end onClick={closeMenu}>
          Home
        </NavLink>

        {/* Company */}

        <button
          className="mobile-dropdown-btn"
          onClick={() => toggleDropdown("company")}
        >
          Company
          <FiChevronDown />
        </button>

        <div
          className={`mobile-dropdown ${openDropdown === "company" ? "open" : ""
            }`}
        >
          <NavLink to="/about" onClick={closeMenu}>
            About Us
          </NavLink>

          <NavLink to="/our-story" onClick={closeMenu}>
            Our Story
          </NavLink>

          <NavLink to="/mission-vision" onClick={closeMenu}>
            Mission & Vision
          </NavLink>

        </div>

        {/* Solutions */}

        <button
          className="mobile-dropdown-btn"
          onClick={() => toggleDropdown("services")}
        >
          Solutions
          <FiChevronDown />
        </button>

        <div
          className={`mobile-dropdown ${openDropdown === "services" ? "open" : ""
            }`}
        >
          <NavLink to="/retail" onClick={closeMenu}>
            Retail
          </NavLink>

          <NavLink to="/healthcare" onClick={closeMenu}>
            Healthcare
          </NavLink>

          <NavLink to="/agriculture" onClick={closeMenu}>
            Agriculture
          </NavLink>

          <NavLink to="/education" onClick={closeMenu}>
            Education
          </NavLink>

          <NavLink to="/manufecturing" onClick={closeMenu}>
            Manufecturing
          </NavLink>

          <NavLink to="/logistics" onClick={closeMenu}>
            Logistics
          </NavLink>

           <NavLink to="/grocery" onClick={closeMenu}>
            Grocery
          </NavLink>

           <NavLink to="/fashion" onClick={closeMenu}>
            Fashion
          </NavLink>
        </div>



        <NavLink to="/contact" onClick={closeMenu}>
          Contact
        </NavLink>

        <NavLink
          to="/get-quote"
          className="quote-btn mobile-btn"
          onClick={closeMenu}
        >
          Get Quote
        </NavLink>

      </div>
    </header>
  );
};

export default Header;